import dynamic from 'next/dynamic'
import { alpha } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'

// Types
import type { StatCardProps } from '@/types/components/molecules/solution'

// Components
const CountUpAtom = dynamic(() => import('@/components/atoms/animation/count-up'))

// Big animated number with a label; used in the hero, the problem section and the results
const StatCardMolecule = (props: StatCardProps) => {
	// Props
	const { lng, value, prefix, suffix, label, caption, subCaption, variant = 'light' } = props

	// Variables
	const dark = variant === 'dark'

	return (
		<Box
			sx={{
				height: 1,
				p: { xs: 2.5, md: 3 },
				borderRadius: 4,
				...(variant === 'glass' && {
					bgcolor: alpha('#fff', 0.72),
					backdropFilter: 'blur(16px) saturate(160%)',
					WebkitBackdropFilter: 'blur(16px) saturate(160%)',
					boxShadow: '0 20px 40px -16px rgba(23, 23, 23, 0.25)',
					border: `1px solid ${alpha('#fff', 0.6)}`
				}),
				...(variant === 'light' && { bgcolor: 'common.white', boxShadow: '0 1px 2px rgba(23, 23, 23, 0.04)' }),
				...(dark && { bgcolor: alpha('#fff', 0.06), border: `1px solid ${alpha('#fff', 0.12)}` })
			}}
		>
			<Typography
				sx={{
					fontSize: variant === 'glass' ? 32 : { xs: 36, md: 48 },
					fontWeight: 700,
					lineHeight: 1.2,
					color: dark ? 'secondary.light' : variant === 'light' ? 'primary.main' : 'secondary.main'
				}}
			>
				<CountUpAtom lng={lng} value={value} prefix={prefix} suffix={suffix} />
			</Typography>

			<Typography sx={{ mt: 1, fontSize: variant === 'glass' ? 13 : 15, lineHeight: 1.8, color: dark ? 'grey.300' : 'text.secondary' }}>{label}</Typography>

			{caption && <Typography sx={{ mt: 2, fontSize: 15, fontWeight: 700, color: dark ? 'common.white' : 'text.primary' }}>{caption}</Typography>}

			{subCaption && <Typography sx={{ fontSize: 13, color: dark ? 'grey.400' : 'text.secondary' }}>{subCaption}</Typography>}
		</Box>
	)
}

export default StatCardMolecule
